import React from 'react';
import { AppHeader } from '../shared';
import { BgAnimate } from '../shared';
import { BurgerMenu } from '../menu/Menu';
import { getMenuGameLinks } from '../../config/gameLinks';
import { appVariant } from '../../config';
import { useTranslation } from '../../i18n';

interface PaymentScreenWrapperProps {
  children: React.ReactNode;
}

const PaymentScreenWrapper: React.FC<PaymentScreenWrapperProps> = ({ children }) => {
  const { t } = useTranslation();

  const getGameType = (): 'blitz' | 'team' | 'family' | 'party' => {
    const variantMap: Record<string, 'blitz' | 'team' | 'family' | 'party'> = {
      blitz: 'blitz',
      team: 'team',
      family: 'family',
      party: 'party',
      new: 'party',
      coop: 'blitz',
    };
    return variantMap[appVariant] || 'blitz';
  };

  const gameLinks = getMenuGameLinks(getGameType());
  
  const menuItems = [
    {
      id: 'play-another-game-header',
      label: t('lobby.menu.playAnotherGamePack'),
      isSectionHeader: true,
    },
    ...gameLinks.map(link => ({
      id: link.id,
      label: link.name,
      href: link.url,
    })),
  ];

  return (
    <div className="app payment-screen-wrapper" style={{ position: 'relative' }}>
      <BgAnimate speed={2.0} delayBetweenCycles={2000} />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <AppHeader
          rightButton={undefined}
          rightContent={<BurgerMenu items={menuItems} />}
        />
        {children}
      </div>
    </div>
  );
};

export default PaymentScreenWrapper;
